"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/** Because including a node module for this stuff would be *ridiculous* */
exports.resolveKey = function (path, obj) {
    return path.split('.').reduce(function (prev, curr) {
        return (prev ? prev[curr] : undefined);
    }, obj);
};
exports.setKey = function (path, obj, value) {
    var curr = obj;
    path.split('.').map(function (next, i, arr) {
        if (i < (arr.length - 1)) {
            if (curr[next] === undefined || typeof curr[next] === 'string') {
                curr[next] = {};
            }
            curr = curr[next];
        }
        else {
            curr[next] = value;
        }
    }, obj);
    return obj;
};
exports.deleteKey = function (path, obj) {
    if (path.indexOf('.') === -1) {
        delete obj[path];
    }
    var split = path.split('.');
    var finalKey = split.pop();
    var parentPath = split.join('.');
    var parent = exports.resolveKey(parentPath, obj);
    if (parent) {
        delete parent[finalKey];
        if (Object.keys(parent).length === 0) {
            exports.deleteKey(parentPath, obj);
        }
    }
};
exports.prefixKeys = function (obj, prefix) {
    if (typeof obj !== 'object' || !obj || obj instanceof Array) {
        return false;
    }
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        obj[prefix + key] = obj[key];
        delete obj[key];
    });
    return obj;
};
exports.deepMap = function (obj, func) {
    return lodash_1.transform(obj, function (result, val, key) {
        result[key] = lodash_1.isObject(val) ? exports.deepMap(val, func) : func.call(obj, val, key);
    });
};
exports.deepClean = function (obj) {
    for (var prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
            continue;
        }
        if (obj[prop] === null || obj[prop] === undefined) {
            delete obj[prop];
        }
        if (typeof obj[prop] === 'object') {
            obj[prop] = exports.deepClean(obj[prop]);
            if (Array.isArray(obj) && Object.keys(obj[prop]).length === 0) {
                obj.splice(parseInt(prop, 10), 1);
            }
            else if (Object.keys(obj[prop]).length === 0) {
                delete obj[prop];
            }
        }
    }
    return obj;
};
exports.flatten = function (obj, out, paths) {
    if (out === void 0) { out = {}; }
    if (paths === void 0) { paths = []; }
    return Object.getOwnPropertyNames(obj).reduce(function (outObj, key) {
        paths.push(key);
        if (typeof obj[key] === 'object') {
            exports.flatten(obj[key], outObj, paths);
        }
        else {
            outObj[paths.join('.')] = obj[key];
        }
        paths.pop();
        return outObj;
    }, out);
};
